import { Container } from 'ui/container'
import { MinesAdmin } from 'features/admin/mines'
import { Link } from 'react-router-dom'
import { routes } from 'core/routes/paths'

import c from '../assets/sass/page.module.scss'

const AdminMinesPage = () => {
    return (
        <div className={c.component}>
            <div className={c.header}>
                <Link to={routes.admin} className={c.back}>
                    ← Назад
                </Link>
                <span className={c.title}>Мины</span>
            </div>
            <Container>
                <MinesAdmin />
            </Container>
        </div>
    )
}

export default AdminMinesPage
